import { DevUserCreationRequest, DevUserCreationResponse } from '@/types/service/devUser';

import { baseProtectedApi } from '@/store/baseApi';

export const devUserApi = baseProtectedApi.injectEndpoints({
  endpoints: (builder) => ({
    createDevUser: builder.mutation<DevUserCreationResponse, DevUserCreationRequest>({
      query: (data) => ({
        url: '/v1/protected/dev-user/create',
        method: 'POST',
        data: data,
      }),
    }),
  }),
});

export const { useCreateDevUserMutation } = devUserApi;
